import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { EventLog, LogType } from 'src/lib/fliko/models/eventLog.data';
import { DatabaseService } from 'src/app/shared/services/database.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class EventLogService {
  constructor(
    private dbSrv: DatabaseService,
    private localStorageSrv: LocalStorageService
  ) {}

  /**
   * @path /eventLog/$estateId/
   * @key id
   */
  private get eventLog() {
    return this.dbSrv.estateFactory.getCollection<EventLog>('eventLog/$eId');
  }

  private eventLogByType = (type: LogType) =>
    this.dbSrv.estateFactory.getCollectionReadOnly<EventLog>('eventLog/$eId', { by: { child: 'logType' }, equalTo: type });

  public getEventLogs$(): Observable<EventLog[]> {
    return this.eventLog.getList();
  }

  public getEstateNewErrorEventLog$(estateId: string): Observable<EventLog[]> {
    return this.eventLogByType(LogType.ERROR)
      .getList()
      .pipe(
        map((errors) =>
          errors.filter((item) => {
            let matched = true;
            const storageLog = this.localStorageSrv.errorLog.get(estateId);
            if (storageLog) {
              const lastLog = JSON.parse(storageLog);
              matched = item.date > lastLog.date;
            }
            return matched;
          })
        )
      );
  }
}
